import React from "react";
import { Button } from "./ui";

interface Props {
  children: React.ReactNode;
}
interface State {
  error: Error | null;
}

/** Global error boundary so an exception in any tool renders a recoverable
 *  fallback instead of a blank white screen. */
export default class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error("OAB ErrorBoundary caught:", error, info);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <div
        style={{
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 16,
          padding: 40,
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: 18, fontWeight: 600, color: "var(--fg-primary)" }}>
          Something went wrong
        </div>
        <div
          className="mono"
          style={{
            maxWidth: 640,
            fontSize: 12.5,
            color: "var(--status-err)",
            background: "var(--status-err-bg)",
            border: "1px solid var(--border-subtle)",
            borderRadius: "var(--r-md)",
            padding: "12px 16px",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
          }}
        >
          {error.message || String(error)}
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <Button variant="primary" icon="refresh" onClick={() => this.setState({ error: null })}>
            Try again
          </Button>
          <Button variant="default" onClick={() => window.location.reload()}>
            Reload app
          </Button>
        </div>
      </div>
    );
  }
}
